module.exports = __webpack_public_path__ + "static/img/fxcd.0762159.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fxcd.png
// module id = WMJh
// module chunks = 1